import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AuthImage = ({ path, alt, className, testid }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let blobUrl;
    let active = true;
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then(({ data }) => {
        if (!active) return;
        blobUrl = URL.createObjectURL(data);
        setUrl(blobUrl);
      })
      .catch(() => {});
    return () => {
      active = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [path]);

  if (!url) return <div className={`bg-muted animate-pulse ${className}`} />;
  return <img src={url} alt={alt} className={className} data-testid={testid} />;
};
